import { useState } from 'react';
import { useBreakpoint, Breakpoints, useNextgenRouter } from '@nextgen-web-framework/all';
import { ConfigService } from '@nextgen-web-framework/core';
import SharebarDrawer from '../SharebarDrawer/SharebarDrawer';
import { useShareUserConfig } from '../../utils/sharebar/sharebarHelpers';
import { MePanelSharebarContainerProps } from './types/propTypes';
import styles from './MePanelSharebar.module.scss';
const MePanelSharebar = ({ children, userType }: MePanelSharebarContainerProps) => {
  const viewPortType = useBreakpoint();
  const isMobile = [Breakpoints.SM, Breakpoints.XS].includes(viewPortType as Breakpoints);
  const [showSharebarDrawer, setShowSharebarDrawer] = useState(false);
  const onCloseHandler = () => setShowSharebarDrawer(false);
  const drawerClickHandler = () => setShowSharebarDrawer(!showSharebarDrawer);
  const { shareTitle, shareDescription } = useShareUserConfig(userType);
  const router = useNextgenRouter();
  const configs = ConfigService.getConfigs();
  const WEB_BASE_PATH = configs.NEXT_PUBLIC_WEB_BASE_PATH as string;
  const sharebarURL = `${WEB_BASE_PATH}/${router.params?.locale}/signup?flowName=shareBarFlow&returnUri=/cart`;
  return (
    <div className={styles['me-panel-sharebar-container']} data-testid="me-panel-sharebar-test-id">
      <div
        role="presentation"
        onKeyDown={drawerClickHandler}
        onClick={drawerClickHandler}
        data-testid="sharebar-button-test-id"
      >
        {children}
      </div>
      {showSharebarDrawer && (
        <SharebarDrawer
          backBtn={!isMobile}
          accountType={userType}
          shareTitle={shareTitle}
          shareDesc={shareDescription}
          fullUrl={sharebarURL}
          onClose={onCloseHandler}
        />
      )}
    </div>
  );
};

export default MePanelSharebar;
